import { Box, CircularProgress, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import CreditNoteEdit from "./CreditNoteEdit";
import { useCreditNoteLoader } from "../hooks/CreditNoteLoaderHook";
import { createEmptyCreditNote } from "../types/CommercialDocumentTypes";

import type { CreditNote } from "../types/CommercialDocumentTypes";

export const CreditNoteEditPage = () => {
	const { id } = useParams<{ id: string }>();
	const { t } = useTranslation();

	const [creditNote, setCreditNote] = useState<CreditNote>(createEmptyCreditNote());
	const [hasCreditNote, setHasCreditNote] = useState<boolean>(false);

	const { fetchData, loading } = useCreditNoteLoader({
		onFetched: (loadedCreditNote) => {
			setCreditNote(loadedCreditNote);
			setHasCreditNote(true);
		},
	});

	useEffect(() => {
		setHasCreditNote(false);
		if (id && id !== "new") {
			// Edit existing credit note
			fetchData(id);
		} else if (id === "new") {
			// Create new credit note
			setCreditNote(createEmptyCreditNote());
			setHasCreditNote(true);
		}
	}, [id]);

	if (loading) {
		return (
			<Box display="flex" justifyContent="center" alignItems="center" height="100vh">
				<CircularProgress />
			</Box>
		);
	}

	if (!hasCreditNote) {
		return (
			<Box textAlign="center" p={3}>
				<Typography variant="h6">{t("nothing-available")}</Typography>
			</Box>
		);
	}

	return <CreditNoteEdit creditNote={creditNote} setCreditNote={setCreditNote} />;
};
